import { cn } from "@nexus/ui";

export type StatusChipTone = "default" | "amber" | "rose" | "emerald";

const TONE_ACTIVE_CLASS: Record<StatusChipTone, string> = {
  default: "border-primary/40 bg-primary/10 text-primary",
  amber:   "border-amber-300/60 bg-amber-100/70 text-amber-800 dark:border-amber-700/40 dark:bg-amber-950/40 dark:text-amber-200",
  rose:    "border-rose-300/60 bg-rose-100/70 text-rose-800 dark:border-rose-700/40 dark:bg-rose-950/40 dark:text-rose-200",
  emerald: "border-emerald-300/60 bg-emerald-100/70 text-emerald-800 dark:border-emerald-700/40 dark:bg-emerald-950/40 dark:text-emerald-200",
};

interface StatusChipProps {
  active: boolean;
  count?: number;
  label: string;
  onClick: () => void;
  tone?: StatusChipTone;
}

/** Single-select status filter pill with an optional count badge and tone. */
export function StatusChip({ active, count, label, onClick, tone = "default" }: StatusChipProps) {
  const toneClass = active
    ? TONE_ACTIVE_CLASS[tone]
    : "border-border bg-transparent text-muted-foreground hover:border-foreground/30 hover:text-foreground";

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn("inline-flex select-none items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors", toneClass)}
    >
      {label}
      {typeof count === "number" && (
        <span className={cn(
          "rounded-full px-1.5 text-[10px] tabular-nums leading-[1.4]",
          active ? "bg-foreground/10" : "bg-muted text-muted-foreground",
        )}>
          {count}
        </span>
      )}
    </button>
  );
}
